export function getPartnersKey(lang) {
    return `partners<${lang}>`;
}

export function getPartnersValueKey(lang) {
    return `value-${lang}`;
}
